import React, { useState } from 'react';

const AddSensorPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showAddSensorPopup,setShowAddSensorPopup] = useState<boolean>(false);

    const addSensorToggleHandler = () => {
        setShowAddSensorPopup(!showAddSensorPopup);
    }
	
	return <Component showAddSensorPopup={showAddSensorPopup} addSensorToggleHandler={addSensorToggleHandler} {...props}/>;
};

export default AddSensorPopupHOC;   